import { Component, OnDestroy, OnInit } from '@angular/core';
import { AdminService } from 'app/admin/admin.service';
import { NofshonNirshamimExportExcel } from 'app/admin/interface/reports/export-excel/nofshon-nirshamim.interface';
import { NofshonNirshamimReport } from 'app/admin/interface/reports/nofshon-nirshamim-report.interface';
import { INofesh } from 'app/nofesh/model/nofesh';
import { NofeshService } from 'app/nofesh/nofesh.service';
import { ConfigService } from 'app/shared/config.service';
import { ENofeshType } from 'app/shared/enums/enofesh-type.enum';
import { ESugNirsham } from 'app/shared/enums/sug-nirsham.enum';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';



@Component({
  selector: 'app-nofshon-nirshamim',
  templateUrl: './nofshon-nirshamim.component.html',
  styleUrls: ['./nofshon-nirshamim.component.css']
})
export class NofshonNirshamimComponent implements OnInit, OnDestroy {

  isReportLoaded: boolean = false;
  nirshamim: NofshonNirshamimReport[];
  nofashim: INofesh[];
  selectedNofeshId: string = "0";
  selectedNofesh: INofesh;
  reportIssueTime: string;
  private _intervalId;
  private readonly _itervalTime: number = 1 * 60 * 1000;
  updateIntervalMinutes: number = this._itervalTime / (60 * 1000);
  sugNirsham: typeof ESugNirsham = ESugNirsham;
  nofeshTypes: typeof ENofeshType = ENofeshType;
  get isNofeshChul() 
  { 
    return this.selectedNofesh.nofeshType === ENofeshType.NofeshChul ||
      this.selectedNofesh.nofeshType === ENofeshType.MeurganimChul ||
      this.selectedNofesh.nofeshType === ENofeshType.MishpachotChul;
  };

  readonly exportExcelUrl: string;
  exportExcelFilename: string;
  exportExcelData: NofshonNirshamimExportExcel;

  constructor(
    private _configService: ConfigService,
    private _adminService: AdminService, 
    private _nofeshService: NofeshService,
    private _userMessages: UserMessagesService
  ) 
  { 
    this.exportExcelUrl = `${this._configService.getConfigPropertyByKey("apiUrl")}/api/Admin/ExportNofshonNirshamimReportToExcel`;
  }

  ngOnInit() {
    if(sessionStorage.hasOwnProperty("nofashim"))
    {
      this.nofashim = JSON.parse(sessionStorage.getItem("nofashim"));
    }
    else
    {
      this._getAllNofashim();
    }
  }

  private _getAllNofashim(): void
  {
    this._nofeshService.getAllNofashim().subscribe((response: ResultOfOperation<INofesh[]>) => {
      if (response.isSuccess) 
      {
        this.nofashim = response.data.filter((nofshon: INofesh) => {
            return (nofshon.nofeshType == ENofeshType.NofeshPnim ||
                    nofshon.nofeshType == ENofeshType.MeurganimPnim ||
                    nofshon.nofeshType == ENofeshType.NofeshChul ||
                    nofshon.nofeshType == ENofeshType.MishpachotChul
                  ) && nofshon.k_pail == 1;
          });

          sessionStorage.setItem("nofashim", JSON.stringify(this.nofashim));
      }
      else 
      {
        this._userMessages.setErrorMessage("אירעה שגיאה בטעינת רשימת הנופשים");
      }
    },
    error => {
      this._userMessages.setErrorMessage("אירעה שגיאה בטעינת הנתונים");
    });
  }

  getNofeshTitle(nofesh: INofesh): string
  {
    return `${nofesh.nofeshTitle} - ${this._formatDate(nofesh.toTkufatNofesh)} - ${this._formatDate(nofesh.fromTkufatNofesh)}`;
  }

  private _formatDate(date: Date): string
  {
    if(typeof date !== "object")
    {
      date = new Date(date);
    }

    const result = date.toLocaleDateString("he-IL").replace(/\./g, "/");
    return result;
  }

  onNofeshSelected(): void
  {
    if(this._intervalId)
    {
      clearInterval(this._intervalId);
      this._intervalId = null;
    }

    this.nirshamim = null;
    this.reportIssueTime = null;
    this.exportExcelData = null;
    this.exportExcelFilename = null;
    this.selectedNofesh = null;
    this.isReportLoaded = false;

    if(this.selectedNofeshId === "0") 
    {
      return;
    }

    this.selectedNofesh = this.nofashim.find(n => n.id_nofesh === +this.selectedNofeshId);
    this._getNirshmimReport();

    this._intervalId = setInterval(() => {
      this._getNirshmimReport();
    }, this._itervalTime);
  }

  private _getNirshmimReport(): void
  {
    this._adminService.getNofshonNirshamimReport(this.selectedNofeshId).subscribe((response: NofshonNirshamimReport[]) => {
      this.isReportLoaded = true;
      this.reportIssueTime = this._adminService.getReportIssueTime();
      this.nirshamim = response;
      this.exportExcelData = {
        content: this.nirshamim,
        timestamp: this.reportIssueTime,
        header: `סיכום נרשמים - ${this.getNofeshTitle(this.selectedNofesh)}`,
        password: null
      };
      this.exportExcelFilename = this.exportExcelData.header.replace(/\//g, "_");
    }, error => {
      console.error(error);
    });
  }

  ngOnDestroy(): void
  {
    if(this._intervalId)
    {
      clearInterval(this._intervalId);
    }
  }

}
